import React, { useState, useEffect } from 'react';
import './Insert-Playlist.scss';
import 'rc-pagination/assets/index.css';
import Pagination from 'rc-pagination';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';



const InsertPlaylist = (props) => {

    const config = new Configurations()


    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (!props.isOpen) {
            setTipoPlaylist(null);
            setPlaylistSelecionada(null);
            setListaPlaylists([]);
            setHasError(false)
        }
    }, [props.isOpen]);


    const tiposPlaylist = [
        { tipo: 'video', label: 'Vídeos', icone: 'fas fa-film' },
        { tipo: 'podcast', label: 'Podcasts', icone: 'fas fa-podcast' },
    ]

    const [tipoPlaylist, setTipoPlaylist] = useState(null);

    const [playlistSelecionada, setPlaylistSelecionada] = useState(null),
        selecionaPlaylist = (_playlist) => {
            setPlaylistSelecionada(_playlist);
        }

    const labelTipoPlaylist = () => {
        const _tipo = tiposPlaylist.filter(item => item.tipo === tipoPlaylist)[0];
        return _tipo ? _tipo.label : '';
    }

    const { handleModalPlaylist, toggle, isLoadingInserirPlaylist, flagContent
    } = props;


    const
        onChangePage = (page) => {
            carregaListaPlaylists(tipoPlaylist, page)
        }

    const [pagina, setPagina] = useState(1)
    const [paginacaoPlaylists, setPaginacaoPlaylists] = useState({})
    const [isLoadingPlaylists, setIsLoadingPlaylists] = useState(false)
    const [listaPlaylists, setListaPlaylists] = useState([]);
    const playlistsPorPagina = 10;


    const selecionaTipoPlaylist = (_tipo) => {
        setTipoPlaylist(_tipo)
        carregaListaPlaylists(_tipo)
    }

    const carregaListaPlaylists = (_tipo, _pagina = 1) => {
        setIsLoadingPlaylists(true)
        setPagina(_pagina)
        setPlaylistSelecionada(null)

        axios.get(config.apiBasePath + `/playlist/${_tipo}?page=${_pagina}&pageSize=${playlistsPorPagina}`)

            .then(response => {
                setListaPlaylists(response.data.data || [])
                setPaginacaoPlaylists(response.data.paginacao || {})
                setHasError(false)
            })
            .catch(handleError)
            .finally(() => setIsLoadingPlaylists(false));
    }

    // a listagem de playlists não devolve a contagem total de registros: enquanto a página vier
    // cheia assume que existe uma próxima. Se a API passar a devolver paginacao, ela é usada.
    const totalPaginacao = () => {
        if (paginacaoPlaylists.totalPaginas) return paginacaoPlaylists.totalPaginas * playlistsPorPagina;
        return listaPlaylists.length < playlistsPorPagina ? pagina * playlistsPorPagina : (pagina + 1) * playlistsPorPagina;
    }


    const handleError = (err) => {
        setHasError(true)
        setErrorMessage((err.response && !!err.response.data.message) ? err.response.data.message : 'Erro inesperado.')
    }

    return (
        <Modal size="lg" isOpen={props.isOpen} toggle={toggle} returnFocusAfterClose={false}>
            <ModalHeader toggle={toggle}>{flagContent ? "Incluir playlist" : "Inserir playlist"}</ModalHeader>
            <ModalBody>
                <div className="row no-gutters insert-video">
                    {tipoPlaylist === null ? (
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-12 text-center">
                                    <strong>Tipo de Playlist</strong>
                                </div>

                                <div className="col-12 px-3">
                                    <div className="row">
                                        {tiposPlaylist.map((item, index) => {
                                            return (
                                                <div onClick={() => selecionaTipoPlaylist(item.tipo)} key={`tipo-${index}`} className="col-6 p-2 cursor-pointer">
                                                    <div className="btn btn-outline-primary btn-block py-4">
                                                        <i className={`${item.icone} fa-2x d-block mb-2`}></i>
                                                        {item.label}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="col-12">
                            <div className="row no-gutters">
                                <div className="col-9 text-left px-2">
                                    <h3>Playlists de "{labelTipoPlaylist()}"</h3>
                                </div>
                                <div className='col-3 text-right px-2'>
                                    <button className='btn btn-outline-secondary' onClick={() => setTipoPlaylist(null)}>voltar</button>
                                </div>
                                <div className="col-12 text-left px-2">
                                    <strong>Lista de Playlists</strong>
                                </div>

                                <div className="col-12 px-3">
                                    {isLoadingPlaylists ? (
                                        <div className="row">
                                            <div className="col-12 py-5 text-center">
                                                <div className="spinner-border text-primary" role="status" />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            {listaPlaylists.length > 0 ? listaPlaylists.map((playlist, index) => {
                                                return (
                                                    <div onClick={() => selecionaPlaylist(playlist)} key={`playlist-${index}`} className={'col-4 p-2 cursor-pointer' + (!!playlistSelecionada && playlist.id === playlistSelecionada.id ? ' episodio-selecionado' : '')}>
                                                        <img className="img img-fluid img-episodio" src={playlist.image} alt={'capa-' + playlist.nomePlaylist} />
                                                        <p className="m-0"><strong>{playlist.nomePlaylist}</strong></p>
                                                        <p className="m-0"><small>{playlist.quantidadeItens || 0} {tipoPlaylist === 'video' ? 'vídeo(s)' : 'podcast(s)'}</small></p>
                                                    </div>
                                                )
                                            }) : (
                                                <React.Fragment>
                                                    {hasError ? (
                                                        <div className='col-12 text-center text-danger'>
                                                            <p>{errorMessage}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="col-12 p-2 text-center">
                                                            <p className="m-0">Não há playlists disponíveis para esse tipo.</p>
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {isLoadingInserirPlaylist ? (
                                    <div className="col-12 py-4 text-center">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className="col-12 py-4 text-center">
                                        <button disabled={!playlistSelecionada} onClick={() => handleModalPlaylist({ tipo: (tipoPlaylist === 'video' ? 'videos' : tipoPlaylist), playlist: playlistSelecionada })} className="btn btn-outline-success">{flagContent ? "Incluir playlist" : "Inserir playlist"}</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {tipoPlaylist !== null && listaPlaylists.length > 0 && (
                        <div className="col-12 mt-2 px-0">
                            <div className="paginacao-videos">
                                <Pagination onChange={onChangePage} current={pagina} total={totalPaginacao()} pageSize={playlistsPorPagina} />
                            </div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
}

export default InsertPlaylist;
